module.exports = __webpack_public_path__ + "04_short_brown.5da78330.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/04_short_brown.png
// module id = MnhR
// module chunks = 0